/* ==========================================================================
   GGMVN Theme JavaScript
   ========================================================================== */

(function() {
  'use strict';

  /* ---------- Header scroll effect ---------- */
  const header = document.querySelector('.header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* ---------- Mobile menu toggle ---------- */
  const menuToggle = document.querySelector('.header__menu-toggle');
  const nav = document.querySelector('.header__nav');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', () => {
      nav.style.display = nav.style.display === 'flex' ? 'none' : 'flex';
      nav.style.position = 'absolute';
      nav.style.top = 'var(--header-height)';
      nav.style.left = '0';
      nav.style.right = '0';
      nav.style.background = 'var(--color-white)';
      nav.style.flexDirection = 'column';
      nav.style.padding = 'var(--spacing-md)';
      nav.style.borderBottom = '1px solid rgba(0,0,0,0.08)';
    });
  }

  /* ---------- Product variant selection ---------- */
  document.querySelectorAll('.product__variant-option').forEach(option => {
    option.addEventListener('click', function() {
      const siblings = this.closest('.product__variant-options').querySelectorAll('.product__variant-option');
      siblings.forEach(s => s.classList.remove('active'));
      this.classList.add('active');
    });
  });

  /* ---------- Intersection Observer for scroll animations ---------- */
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.product-card, .split-feature, .brand-statement').forEach(el => {
    observer.observe(el);
  });

})();
